var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgItem3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 107.15 121.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: none;\r\n        stroke: #cdaa69;\r\n        stroke-linejoin: round;\r\n        stroke-width: .25px;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-dasharray: 0 0 1.5 1;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.57 7.04 76.84 20.47 100.11 33.9 100.11 60.77 100.11 87.64 76.84 101.07 53.57 114.51 30.3 101.07 7.04 87.64 7.04 60.77 7.04 33.9 30.3 20.47 53.57 7.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.62 41.11 87.62 60.77 87.62 80.43 70.6 90.26 53.57 100.09 36.55 90.26 19.52 80.43 19.52 60.77 19.52 41.11 36.55 31.28 53.57 21.45 70.6 31.28 87.62 41.11"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 53.57,
    y1: 7.04,
    x2: 53.57,
    y2: 114.51
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 100.11,
    y1: 33.9,
    x2: 7.04,
    y2: 87.64
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 100.11,
    y1: 87.64,
    x2: 7.04,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "87.62 41.11 70.6 70.6 53.57 100.09 36.55 70.6 19.52 41.11 53.57 41.11 87.62 41.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.57,.12c3.82,0,6.91,3.09,6.91,6.91s-3.09,6.91-6.91,6.91-6.91-3.09-6.91-6.91S49.76,.12,53.57,.12Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 53.57,
    cy: 60.77,
    r: 39.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.09,30.45c1.91,3.31,.78,7.53-2.53,9.44-3.3,1.91-7.53,.78-9.44-2.53-1.91-3.3-.78-7.53,2.53-9.44,3.3-1.91,7.53-.78,9.44,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M106.1,91.09c-1.91,3.31-6.14,4.44-9.44,2.53-3.3-1.91-4.44-6.14-2.53-9.44,1.91-3.3,6.14-4.44,9.44-2.53,3.3,1.91,4.44,6.13,2.53,9.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.57,121.42c-3.82,0-6.91-3.09-6.91-6.91,0-3.82,3.09-6.91,6.91-6.91s6.91,3.09,6.91,6.91c0,3.82-3.09,6.91-6.91,6.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.05,91.1c-1.91-3.31-.78-7.53,2.53-9.44,3.3-1.91,7.53-.78,9.44,2.53,1.91,3.3,.78,7.53-2.53,9.44-3.3,1.91-7.53,.78-9.44-2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.05,30.45c1.91-3.31,6.14-4.44,9.44-2.53,3.31,1.91,4.44,6.14,2.53,9.44-1.91,3.3-6.14,4.44-9.44,2.53-3.31-1.91-4.44-6.13-2.53-9.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.52,40.11c.55,0,1,.45,1,1s-.45,1-1,1-1-.45-1-1,.45-1,1-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.44,20.95c.28,.48,.11,1.09-.37,1.37-.48,.28-1.09,.11-1.37-.37-.28-.48-.11-1.09,.37-1.37,.48-.28,1.09-.11,1.37,.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M88.49,41.61c-.28,.48-.89,.64-1.37,.37-.48-.28-.64-.89-.37-1.37,.28-.48,.89-.64,1.37-.37,.48,.28,.64,.89,.37,1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M87.62,81.43c-.55,0-1-.45-1-1s.45-1,1-1,1,.45,1,1-.45,1-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.71,100.59c-.28-.48-.11-1.09,.37-1.37,.48-.28,1.09-.11,1.37,.37,.28,.48,.11,1.09-.37,1.37-.48,.28-1.09,.11-1.37-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.66,79.93c.28-.48,.89-.64,1.37-.37,.48,.28,.64,.89,.37,1.37-.28,.48-.89,.64-1.37,.37-.48-.28-.64-.89-.37-1.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.44,60.27c.28,.48,.11,1.09-.37,1.37-.48,.28-1.09,.11-1.37-.37-.28-.48-.11-1.09,.37-1.37,.48-.28,1.09-.11,1.37,.37Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItem3);
export default __webpack_public_path__ + "static/media/item3.66835cb2d780bae55f9d40835508fc0c.svg";
export { ForwardRef as ReactComponent };